import { FaInstagram } from 'react-icons/fa6';
import { Link } from 'react-router';

import { footerNavigationGroups, siteNavigationLinks } from '@/data/navigation';
import { ClinicPhoneLink } from '@/components/common/ClinicPhoneLink';
import { clinicSettings } from '@/data/clinic';

import FooterNavigation from './FooterNavigation';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer-local bg-muted text-muted-foreground text-sm py-10 px-6">
      <div className={'max-w-screen-lg mx-auto px-4'}>
        <div className="mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 border-b border-gray-700 pb-10">
          <div className="space-y-2">
            <h2 className="text-lg font-semibold">医療法人文正会 小林歯科医院</h2>
            <p>{clinicSettings.address.display}</p>
            <p>
              電話：
              <ClinicPhoneLink className="footer-phone font-medium text-white" />
            </p>
            <p>駐車場：{clinicSettings.parking}</p>
            <p>
              交通案内の詳細は
              <Link to={siteNavigationLinks.access.href}>こちらのページ</Link>
              をご覧ください。
            </p>
          </div>

          <div className="space-y-2">
            <h2 className="text-lg font-semibold">診療日・時間</h2>
            <p>
              <strong>診療時間</strong>
              <br />
              午前：{clinicSettings.hours.morning}
              <br />
              午後：{clinicSettings.hours.afternoon}（土曜は
              {clinicSettings.hours.saturdayAfternoon}）
            </p>
            <p>
              <strong>診療日</strong>：月・火・水・金・土
            </p>
            <p>
              <strong>休診日</strong>：木・日・祝
            </p>
          </div>
        </div>

        <FooterNavigation groups={footerNavigationGroups} />

        <div className="mt-10 border-t border-gray-700 pt-8 text-center">
          <h2 className="text-base font-semibold">公式SNS</h2>
          <a
            href="https://www.instagram.com/kobayashi_dental_1182/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="医療法人文正会 小林歯科医院の公式Instagram"
            className="mx-auto mt-3 w-fit gap-2"
          >
            <FaInstagram aria-hidden="true" className="size-5 shrink-0" />
            公式Instagram
          </a>
        </div>

        <div className="text-center text-xs mt-10">
          {`© 1993–${currentYear} 医療法人文正会 小林歯科医院`}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
